<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="coming-soon-modal">
      <v-card-title>
        <h2 class="font card-title">¡Importante!</h2>
      </v-card-title>
      <v-card-text class="font card-text">
        ¿Deseas cambiar la administración a {{item.name}}?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel()">No</v-btn>
        <v-btn color="primary" text @click="onAccept()">Si</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { UPDATE_ORGANIZATION__ADMIN_MUTATION } from '../../constants/graphql';
  export default {
    data () {
      return {
      };
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object,
        default: {}
      },
      organizationId: {
        type: Number,
        default: 0
      }
    },
    computed: {
    },
    watch: {
      dialog (val) {
        this.$emit('update:dialog', !!val);
      }
    },
    methods: {
      onCancel () {
        this.$emit('update:dialog', false);
      },
      onAccept () {
        this.$apollo.mutate({
          mutation: UPDATE_ORGANIZATION__ADMIN_MUTATION,
          variables: {
            userId: this.item.id,
            orgId: this.organizationId
          }
        });
        this.$emit('update:dialog', false);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ChangeAdminModal.vue?772e3f38